module.exports = __webpack_public_path__ + "img/download-document.2dafcc9c.svg";